module.exports = __webpack_public_path__ + "media/28.75e16cc0.mp3";